// Feedback survey link. When a new survey goes live, change this value.
// Opened from the "Give your feedback" button in the Help modal.

export const SURVEY_URL = 'https://eu.posthog.com/external_surveys/019f6bb8-56cc-0000-bd3f-b3eca8e4fdd2';
